import React, { createContext, useContext, useCallback, useReducer } from 'react'
import _ from 'lodash'
import ProductAPI from 'restAPI/ProductAPI';
import { useActiveUserContext } from 'contexts/ActiveUserContext';

const ProductsAndSubProductsFilterContext = createContext({
    setLoadingOnTreeNode: () => {}
});

const Actions = {
    FETCH: "FETCH",
    LOADING: "LOADING"
  }

function reducer(state, action) {
    switch (action.type) {
      case Actions.FETCH:
      case Actions.LOADING:
        return {
            ...state,
            ...action.payload
        }
      default:
        return state
    }
  }

function setProductAndSubProduct(businessUnitId, response=[], state={}) {
    const products = [];
    response.forEach(res => {
        products.push({...res.product, businessUnitId, subProducts: res.subProducts})
    })
    if (businessUnitId) {
        state[businessUnitId] = {products: _.sortBy(products, 'name'), loading: false};
    }
    return state;
}


export function ProductsAndSubProductsFilterProvider({ children, useFilterdAPI = false }) {
    const activeUser = useActiveUserContext();
    const businessUnitId = activeUser.businessUnitId;
    const [state, dispatch] = useReducer(reducer, {});

    const setNodeLoading = useCallback((buId, state, loading) => {
        dispatch({
            type: 'LOADING',
            payload: {...state, [buId]: {loading, products: []}}
        })
    }, [])

    const fetchData = useCallback((id) => {
        async function getData() {
            const buId = id || businessUnitId;
            if (!state.hasOwnProperty(buId)) {
                try {
                    const { promise, cancel } = useFilterdAPI ? ProductAPI.getFilteredProductsByBU(buId) : ProductAPI.getAllProductsByBU(buId, { fetchTags: true });
                    promise.then(res => {
                        const data = setProductAndSubProduct(buId, res)
                        dispatch({
                            type: 'FETCH',
                            payload: data
                        })
                    })
                    return cancel 
                }catch(err) {
                    console.log('Failed to prefetch in products and subProducts context provider', err)
                    setNodeLoading(buId, state, false)
                }
            }
        }
        getData()
    }, [state, setNodeLoading, businessUnitId, useFilterdAPI])

    // useEffect(fetchData, [fetchData])

    const setLoadingOnTreeNode = useCallback((buId) => {
        setNodeLoading(buId, state, true)
        fetchData(buId)
    }, [state, fetchData, setNodeLoading])

    return (
        <ProductsAndSubProductsFilterContext.Provider value={{state, setLoadingOnTreeNode }} >
            {children}
        </ProductsAndSubProductsFilterContext.Provider>
    )
}

export default ProductsAndSubProductsFilterContext;

export const withProductsAndSubProductsFilterContext = Component => (
    props => (
      <ProductsAndSubProductsFilterContext.Consumer>
        {context => <Component productsAndSubProductsTreeContext={context} {...props} />}
      </ProductsAndSubProductsFilterContext.Consumer>
    )
)

export function useProductsAndSubProductsFilterContext() {
    return useContext(ProductsAndSubProductsFilterContext);
}